"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var territories = {
    pr: {
        name: 'Puerto Rico',
        id: 'PR',
        short: 'PR'
    }
};
exports.territories = territories;
//# sourceMappingURL=territories.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/library/dist/territories.js
// module id = 896
// module chunks = 0